import React from 'react'

import { Box, capitalize, Typography } from "@mui/material"
import OfficeMappingTableField from "Pages/Admin/OfficeMapping/Table/@columns/Inputs/Field"

export default function inputsColumn() {

	return {
		name: 'fields',
		label: 'Fields',
		options: {
			sort: false,
			customHeadLabelRender: ({ name }) => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Typography fontWeight="bold">{capitalize(name)}</Typography>
			</Box>,
			customBodyRowRenderLite: (value, { fieldData }, rowIndex) => <Box
				sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 1 }}>
				{value.map(field => {
					return <OfficeMappingTableField
						label={field}
						value={fieldData[field]}
						key={`${field}-${rowIndex}-${fieldData[field]}`}
						rowIndex={rowIndex}
					/>
				})}
			</Box>,
		}
	}
}